import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/JCRW_Frontend_Build_Service/JCRW/jcrw/src/app/lib/registry.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/JCRW_Frontend_Build_Service/JCRW/jcrw/src/app/style/globals.scss");
